// @flow

import _ from 'lodash';
import * as analyticV2Actions from 'actions/analytics-v2-actions';
import * as analyticV3Actions from 'actions/analytics-v3-actions';

/**
 * Check if the store show analytic v3 (api using data brick) or not ?
 * @param {*} tenantApp
 * @returns
 */
export const enableAnalyticV3 = tenantApp => {
  const enableAnalyticV3 = _.get(tenantApp, 'settings.analyticV3.settings.enable', true);
  return enableAnalyticV3;
};

export const dynamicActionAnalytic = (actionName, ...args) => {
  return (dispatch, getState) => {
    let isEnableAnalyticV3 = true;
    if (process.env.REACT_APP_ENV === 'staging') {
      isEnableAnalyticV3 = true;
    } else {
      const tenantApp = _.get(getState(), 'oauth.tenantApp', {});
      isEnableAnalyticV3 = enableAnalyticV3(tenantApp);
    }
    const actions = isEnableAnalyticV3 ? analyticV3Actions : analyticV2Actions;

    if (typeof actions[actionName] === 'function') {
      return dispatch(actions[actionName](...args));
    } else {
      console.error(
        `Action "${actionName}" not found in ${
          isEnableAnalyticV3 ? 'analyticV3Actions' : 'analyticV2Actions'
        }`
      );
    }
  };
};
